// extracted by mini-css-extract-plugin
export default {"container":"WG-z","disabled":"XG-z","bgBlack":"YG-z","content":"ZG-z","countdown":"_G-z","topCaption":"aH-z","topHeading":"bH-z","heading":"cH-z","copy":"dH-z"};